/** @type {import('@sveltejs/kit').ParamMatcher} */
export function match(param) {
  return /\b[1-9]\d*\b/.test(`${param}`);
}